import { render, staticRenderFns } from "./WizardPageCsrDetails.vue?vue&type=template&id=19660be8&scoped=true&"
import script from "./WizardPageCsrDetails.vue?vue&type=script&lang=ts&"
export * from "./WizardPageCsrDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WizardPageCsrDetails.vue?vue&type=style&index=0&id=19660be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19660be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
